import { createReducer } from '@reduxjs/toolkit';
import { GET_MAINTENANCE_SCHEDULE, Maintenance } from '../actions/maintenance';

type SystemNotificationState = {
  maintenance: Maintenance;
};

const initState: SystemNotificationState = {
  maintenance: {
    current_timestamp: '',
    maintenance_schedule: {
      start_at: '',
      end_at: '',
      description: '',
    },
  },
};

const systemNotificationReducer = createReducer(initState, (builder) =>
  builder.addCase(GET_MAINTENANCE_SCHEDULE, (state, action) => {
    return { ...state, maintenance: action.payload };
  })
);

export default systemNotificationReducer;
